export interface LegacyPhotoWorkgroupItem {
  id: string
  name: string
  color: string
  scheduleCount: number
  hidden: boolean
}

export const legacyPhotoWorkgroupOffices = [
  { id: '1', name: 'Mock 본점' },
  { id: '2', name: 'Mock 2호점' },
  { id: '3', name: 'Mock 교육점' },
]

export const legacyPhotoWorkgroups: LegacyPhotoWorkgroupItem[] = [
  { id: 'WG-101', name: 'Mock 촬영 A', color: '#fff2cc', scheduleCount: 4, hidden: false },
  { id: 'WG-102', name: 'Mock 촬영 B', color: '#d9ead3', scheduleCount: 7, hidden: false },
  { id: 'WG-103', name: 'Mock 보정 A', color: '#cfe2f3', scheduleCount: 0, hidden: false },
  { id: 'WG-104', name: 'Mock 보정 B', color: '#ead1dc', scheduleCount: 2, hidden: false },
  { id: 'WG-105', name: 'Mock 셀렉', color: '#fce5cd', scheduleCount: 5, hidden: false },
  { id: 'WG-106', name: 'Mock 앨범', color: '#d0e0e3', scheduleCount: 0, hidden: false },
  { id: 'WG-107', name: 'Mock 출고', color: '#d9d2e9', scheduleCount: 3, hidden: false },
  { id: 'WG-108', name: 'Mock 지원', color: '#f4cccc', scheduleCount: 1, hidden: false },
  { id: 'WG-109', name: 'Mock 검수', color: '#c9daf8', scheduleCount: 0, hidden: false },
  { id: 'WG-201', name: 'Mock 미표시 A', color: '#eeeeee', scheduleCount: 0, hidden: true },
  { id: 'WG-202', name: 'Mock 미표시 B', color: '#dddddd', scheduleCount: 2, hidden: true },
  { id: 'WG-203', name: 'Mock 미표시 C', color: '#cccccc', scheduleCount: 0, hidden: true },
]
